

// GET Calls for Google
export const GoogleAPI = (path,token) =>{
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer "+token);

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  return fetch("https://www.googleapis.com/tagmanager/v2/"+path, requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));

}

export const GoogleUserDetails = (token) =>{
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer "+token);

  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
  };

  return fetch("https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token="+token, requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));

}

// Parse URL Queries
export const GetQueryVariable = (variable) => {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    //console.log('Query variable %s not found', variable);
}

// SLACK Token request
export const SlackToken = (code, clientId, clientSecret) =>{
  var myHeaders = new Headers();
  //myHeaders.append("Cookie", "b=6n4a6vct6ucidofjw1eh117j2");

  var formdata = new FormData();
  formdata.append("code", code);
  formdata.append("client_secret", clientSecret);
  formdata.append("client_id", clientId);

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: formdata,
    redirect: 'follow'
  };

return fetch("https://slack.com/api/oauth.v2.access", requestOptions)
  .then(response => response.json())
  .catch(error => console.log('error', error));
}


// GOOGLE Token request
export const GoogleToken = (code, clientId, clientSecret) =>{
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  var urlencoded = new URLSearchParams();
  urlencoded.append("code", code);
  urlencoded.append("redirect_uri", window.location.origin);
  urlencoded.append("client_id", clientId);
  urlencoded.append("client_secret",clientSecret);
  urlencoded.append("scope", "");
  urlencoded.append("grant_type", "authorization_code");

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow'
  };

  return fetch("https://oauth2.googleapis.com/token", requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));
}

// Verify Google Token ID
export const GoogleUserId = (id_token) =>{
  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  return fetch("https://www.googleapis.com/oauth2/v3/tokeninfo?id_token="+id_token, requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));
}

export const SaveUserToDB = (authState) =>{
  //let output = {};
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "text/plain");

  var raw = "{\"fullName\":\""+authState.name+"\",\"firstName\":\""+authState.firstName+"\",\"lastName\":\""+authState.lastName+"\",\"email\":\""+authState.email+"\",\"locale\":\""+authState.locale+"\",\"googleAccessToken\":\""+authState.googleAccessToken+"\",\"googleRefreshToken\":\""+authState.googleRefreshToken+"\",\"googleUserId\":\""+authState.googleUserId+"\"}";

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  return fetch("https://vvfv9ty1ic.execute-api.us-east-1.amazonaws.com/prod/users", requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));

}

export const SaveContainerToDB = (container, authState, userId) =>{
  //let output = {};
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "text/plain");

  var raw = "{\"name\":\""+container.name+"\",\"path\":\""+container.path+"\",\"accountId\":\""+container.accountId+"\",\"containerId\":\""+container.containerId+"\",\"publicId\":\""+container.publicId+"\",\"fingerprint\":\""+container.fingerprint+"\",\"userId\":\""+userId+"\",\"googleUserId\":\""+authState.googleUserId+"\"}";

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  return fetch("https://vvfv9ty1ic.execute-api.us-east-1.amazonaws.com/prod/containers", requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));
}

export const SaveScanListToDB = (publicId, versionId) =>{
  //let output = {};
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "text/plain");

  var raw = "{\"publicId\":\""+publicId+"\",\"versionId\":\""+versionId+"\"}";

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  return fetch("https://vvfv9ty1ic.execute-api.us-east-1.amazonaws.com/prod/scanlist", requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error));
}

export const GetliveGTMpayload = (publicId) =>{
  //let output = {};

  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  return fetch("https://www.googletagmanager.com/gtm.js?id="+publicId, requestOptions)
    .then(response =>response.text())
    .then(body => {
            let payload = body.split("var data = ");
            let payloadParsed = payload[1].substring(0, payload[1].indexOf(";\n/*\n\n Copyright The Closure Library Authors."));
            //console.log(payloadParsed);
            return JSON.parse(payloadParsed);
          })
    .catch(error => console.log('error', error));
}
